import React, { useState } from 'react';
import * as yup from 'yup';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import FormButton from '../../../common/FormButton';
import DialogueBox from '../../../common/DialogueBox';
import { formatDate } from '../../../../util/formatUtils';
import { notify } from '../../../../store/actions/globalActions';
import { useYupValidationResolver } from '../../../../util/yupUtils';
import { addNewLabour, getLabourData } from '../../../../api/labour';
import LabourerImage, { imageFieldValidation } from './LabourerImage';
import { LABOUR_DATABASE_URL } from '../../../../constants/routerUrl';
import { FETCH_LABOUR_DATA } from '../../../../store/actions/actionTypes';
import { labourKeys } from '../../../../constants/labourDatabaseConstant';
import { Box, Grid, GridItem, Stack, useDisclosure } from '@chakra-ui/react';
import LabourerInfoSection, { labourerInfoValidation } from './LabourerInfoSection';

const formValidatonSchema = yup.object().shape(
  {
    ...labourerInfoValidation,
    ...imageFieldValidation,
  },
  ['nid', 'birthCertNum'],
);

const AddLabourerForm = ({ millId }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [applicationData, setApplicationData] = useState();

  const resolver = useYupValidationResolver(formValidatonSchema);
  const {
    watch,
    control,
    register,
    setValue,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver,
    mode: 'onChange',
  });

  const onSubmit = (data) => {
    let formData = new FormData();
    formData.append('millId', millId);
    for (let key in labourKeys) {
      labourKeys[key].dbKey === 'status'
        ? null
        : formData.append(
            labourKeys[key].dbKey,
            labourKeys[key].isDate
              ? formatDate(data?.[labourKeys[key].dbKey])
              : data?.[labourKeys[key].dbKey],
          );
    }
    formData.append('employeeImage', data?.employeeImage[0]);
    setApplicationData(formData);
    onOpen();
  };

  const confirmSubmit = async () => {
    const res = await addNewLabour(applicationData);
    if (res.data?.status == 200) {
      dispatch(
        notify({
          title: 'Success',
          description: res.data.msg,
          status: 'success',
          duration: 5000,
        }),
      );
      const response = await getLabourData({ page: 1, pageSize: 10 });
      if (response.data) {
        dispatch({ type: FETCH_LABOUR_DATA, payload: response.data });
      }
      history.push(LABOUR_DATABASE_URL);
    }
  };

  return (
    <>
      <Box as="form" onSubmit={handleSubmit(onSubmit)} mt={4}>
        <Stack bg="white" p={4} borderRadius="sm">
          <Grid templateColumns="repeat(2, 1fr)" gap={2}>
            <GridItem colSpan={2}>
              <LabourerInfoSection register={register} control={control} errors={errors} />
              <LabourerImage
                watch={watch}
                errors={errors}
                control={control}
                setValue={setValue}
                register={register}
                sectionName="Upload Image (optional)"
              />
            </GridItem>
          </Grid>
        </Stack>

        <Stack bg="white" flexDir="column" alignItems="flex-end" p={4}>
          <FormButton type="submit" isLoading={isSubmitting}>
            SUBMIT
          </FormButton>
        </Stack>
      </Box>

      <DialogueBox
        close={onClose}
        alertTitle="Confirm"
        mountControl={isOpen}
        performAction={confirmSubmit}
        alertMessage="Are you sure you want submit these information"
      />
    </>
  );
};

export default AddLabourerForm;
